import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { firstToUpper } from "../../../../../utils/helpers/string";

export const NewValue = ({ value }) => {
    const { t } = useTranslation();

    const hasValue = useMemo(() => {
        if (Array.isArray(value)) {
            return value.length > 0;
        }

        if (typeof value === "string") {
            return value.trim() !== "";
        }

        return value !== undefined && value !== null;
    }, [value]);

    return hasValue ? (
        <span className="px-3 py-1 new-value-style">{value}</span>
    ) : (
        <span className="text-danger">{t(firstToUpper("removed"))}</span>
    );
};
